import { useCallback } from "react";
import axios from "../utils/axios";
import { ACCESS_TOKEN, HOME, REFRESH_TOKEN, ROLES } from "../constants";
import { parseJwt } from "../utils";
import Cookie from "../utils/cookie";

export default function useAuth() {
  const token = Cookie.get(ACCESS_TOKEN);

  const isAnyAdmin = useCallback(() => {
    return (
      token &&
      parseJwt(token) &&
      (parseJwt(token).role.code === ROLES.superAdmin ||
        parseJwt(token).role.code === ROLES.admin)
    );
  }, [token]);

  const role = useCallback(() => {
    return parseJwt(token)?.role?.code;
  }, [token]);

  const id = useCallback(() => {
    return parseJwt(token)?.sub;
  }, [token]);

  //TODO remove partner
  const isPartner = useCallback(() => {
    return (
      token && parseJwt(token) && parseJwt(token).role.code === ROLES.partner
    );
  }, [token]);

  const isSuperAdmin = useCallback(() => {
    return (
      token && parseJwt(token) && parseJwt(token).role.code === ROLES.superAdmin
    );
  }, [token]);

  const isBrandManager = useCallback(() => {
    return (
      token &&
      parseJwt(token) &&
      parseJwt(token).role.code === ROLES.brandManager
    );
  }, [token]);

  const isBrandDriver = useCallback(() => {
    return (
      token &&
      parseJwt(token) &&
      parseJwt(token).role.code === ROLES.brandDriver
    );
  }, [token]);

  const isBrandBudtender = useCallback(() => {
    return (
      token &&
      parseJwt(token) &&
      parseJwt(token).role.code === ROLES.brandBudtender
    );
  }, [token]);

  //logout user
  const logOut = () => {
    Cookie.remove(ACCESS_TOKEN);
    Cookie.remove(REFRESH_TOKEN);
    window.location.href = HOME;
  };

  //login user
  const loginUser = async (data) =>
    await axios.post("/auth/login/worker", data);

  const reLogin = async (refreshToken) => {
    alert("refreshToken: " + refreshToken);
    await axios.post(`/auth/refresh-token`, { refreshToken: refreshToken });
  };

  return {
    loginUser,
    logOut,
    reLogin,
    role: role(),
    id: id(),
    isAnyAdmin: isAnyAdmin(),
    isSuperAdmin: isSuperAdmin(),
    isPartner: isPartner(),
    isBrandManager: isBrandManager(),
    isBrandDriver: isBrandDriver(),
    isBrandBudtender: isBrandBudtender(),
  };
}
